import { split, replace } from 'lodash';
import DOMPurify from 'dompurify';
import moji from 'moji';

const NewLineRegExp = /(\r\n|\n)/g;

export const newLineSeparator = (text) =>
  split(text, NewLineRegExp);

export const replaceNewLineWithBr = (text) =>
  replace(text, NewLineRegExp, '<br>');

export const getUrls = (text) => {
  if (typeof text !== 'string') return [];
  const urls = new Set();
  const regex = new RegExp(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
  const matches = text.match(regex) || [];
  matches.forEach(m => urls.add(m));
  return [...urls];
};

const DOMPurifyOption = {
  ADD_ATTR: ["target", "allow", "allowfullscreen", "frameborder", "scrolling"],
  ADD_TAGS: ["iframe"],
  ALLOW_UNKNOWN_PROTOCOLS: true,
  SAFE_FOR_TEMPLATES: true
};
export const sanitize = (htmlStr) => DOMPurify.sanitize(htmlStr, DOMPurifyOption);

export const prepareTextForRender = (text) => {
  return sanitize(replaceNewLineWithBr(text));
};

const htmlEscapeCharMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

export const escapeHTMLTags = (htmlStr) => {
  const regExpStr = `[${Object.keys(htmlEscapeCharMap).join("")}]`;
  const escapeRegExp = new RegExp(regExpStr, 'g');

  return htmlStr.replace(escapeRegExp, (char) => {
    return htmlEscapeCharMap[char];
  });
};

export const unescapeHTMLSpecialCharacters = (htmlStr) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = htmlStr;
  return txt.value;
};

export const hiraganaToKatakana = (str) =>
  moji(str).convert('HG', 'KK').toString();

export const replaceNumber = (str, value, num = "10") => {
  if (!str) {
    return str;
  }

  return str.replace(new RegExp(num), value);
};

export const emailDomainOptions = (value) => {
  if (!value) return [];
  const allDomain = [
    "icloud.com",
    "gmail.com",
    "yahoo.co.jp",
    "docomo.ne.jp",
    "au.com",
    "ezweb.ne.jp",
    "softbank.ne.jp",
    "i.softbank.ne.jp"
  ]
  const lastIndex = value.lastIndexOf('@');
  if (lastIndex < 0) return []

  const lastResult = value.substring(lastIndex + 1);
  return allDomain.filter(v => v !== lastResult && v.includes(lastResult))
}
